import * as THREE from "three";

/**
 * The procedural box gun — body, barrel, angled grip — for the first-person viewmodel. Barrel points
 * along local -Z (same convention as the viewmodel/camera). Ported from zombies/src/entities/gunmesh.ts.
 */
export function buildGunMesh(color: number): { group: THREE.Group; mats: THREE.MeshLambertMaterial[] } {
  const group = new THREE.Group();
  // emissive material so Pack-a-Punch can make it glow harder each tier
  const mat = new THREE.MeshLambertMaterial({ color, emissive: 0x000000 });
  const body = new THREE.Mesh(new THREE.BoxGeometry(0.12, 0.14, 0.5), mat);
  const barrel = new THREE.Mesh(new THREE.BoxGeometry(0.06, 0.06, 0.35), mat);
  barrel.position.set(0, 0.02, -0.4);
  const grip = new THREE.Mesh(new THREE.BoxGeometry(0.1, 0.2, 0.12), mat);
  grip.position.set(0, -0.16, 0.12);
  grip.rotation.x = 0.3;
  group.add(body, barrel, grip);
  return { group, mats: [mat] };
}
